var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalStockAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1478_26842)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.52 15.64L17.96 17.72C17.651 18.132 17.4965 18.338 17.5001 18.5104C17.5032 18.6604 17.5736 18.8012 17.6918 18.8937C17.8275 19 18.085 19 18.6 19H33.4C33.915 19 34.1725 19 34.3083 18.8937C34.4264 18.8012 34.4968 18.6604 34.4999 18.5104C34.5035 18.338 34.349 18.132 34.04 17.72L32.48 15.64M19.52 15.64C19.696 15.4053 19.784 15.288 19.8955 15.2034C19.9943 15.1284 20.1062 15.0725 20.2254 15.0384C20.36 15 20.5067 15 20.8 15H31.2C31.4933 15 31.64 15 31.7746 15.0384C31.8938 15.0725 32.0057 15.1284 32.1045 15.2034C32.216 15.288 32.304 15.4053 32.48 15.64M19.52 15.64L17.64 18.1467C17.4025 18.4633 17.2838 18.6216 17.1995 18.7959C17.1247 18.9506 17.0701 19.1143 17.0372 19.283C17 19.473 17 19.6709 17 20.0667L17 31.8C17 32.9201 17 33.4802 17.218 33.908C17.4097 34.2843 17.7157 34.5903 18.092 34.782C18.5198 35 19.0799 35 20.2 35L31.8 35C32.9201 35 33.4802 35 33.908 34.782C34.2843 34.5903 34.5903 34.2843 34.782 33.908C35 33.4802 35 32.9201 35 31.8V20.0667C35 19.6709 35 19.473 34.9628 19.283C34.9299 19.1143 34.8753 18.9506 34.8005 18.7959C34.7162 18.6216 34.5975 18.4633 34.36 18.1467L32.48 15.64M30 23C30 24.0609 29.5786 25.0783 28.8284 25.8284C28.0783 26.5786 27.0609 27 26 27C24.9391 27 23.9217 26.5786 23.1716 25.8284C22.4214 25.0783 22 24.0609 22 23",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1478_26842",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_26842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1478_26842",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalStockAdd);
export default __webpack_public_path__ + "static/media/modal-stock-add.034dea5f4670ff3a4b50c77f465e5772.svg";
export { ForwardRef as ReactComponent };